import type { ButtonVariant } from '@/components/ui/Button';
import type { TabAction } from '@/gql/graphql';

/** POS settlement flips — never shown or invoked from admin. */
const ADMIN_HIDDEN_TAB_ACTIONS = new Set<TabAction>([
  'PLACE',
  'PARTIAL_PAID',
  'PAY',
  'PAY_PARTIAL',
  'MARK_PAID',
]);

const TAB_ACTION_ORDER: TabAction[] = [
  'OPEN',
  'REOPEN',
  'CLOSE',
  'PARTIAL_REFUND',
  'REFUND',
  'CANCEL',
  'MARK_LOSS',
  'DOWNLOAD_RECEIPT',
];

export const TAB_ACTION_LABELS: Record<TabAction, string> = {
  OPEN: 'Open',
  REOPEN: 'Reopen',
  CLOSE: 'Close',
  PLACE: 'Place',
  PARTIAL_PAID: 'Mark partial paid',
  PAY: 'Mark paid',
  PAY_PARTIAL: 'Pay partial',
  PARTIAL_REFUND: 'Partial refund',
  REFUND: 'Refund',
  CANCEL: 'Cancel tab',
  MARK_LOSS: 'Mark as loss',
  MARK_PAID: 'Mark paid',
  DOWNLOAD_RECEIPT: 'Download receipt',
};

export const TAB_BULK_ACTIONS: TabAction[] = TAB_ACTION_ORDER.filter(
  (action) => action !== 'DOWNLOAD_RECEIPT' && !ADMIN_HIDDEN_TAB_ACTIONS.has(action),
);

export const TAB_DETAIL_ACTIONS: TabAction[] = TAB_ACTION_ORDER.filter(
  (action) => !ADMIN_HIDDEN_TAB_ACTIONS.has(action),
);

export function orderTabActions(actions: TabAction[]): TabAction[] {
  return [...actions]
    .filter((action) => !ADMIN_HIDDEN_TAB_ACTIONS.has(action))
    .sort((a, b) => {
      const ai = TAB_ACTION_ORDER.indexOf(a);
      const bi = TAB_ACTION_ORDER.indexOf(b);
      if (ai === -1 && bi === -1) return a.localeCompare(b);
      if (ai === -1) return 1;
      if (bi === -1) return -1;
      return ai - bi;
    });
}

export function tabActionLabel(action: TabAction): string {
  return TAB_ACTION_LABELS[action] ?? action;
}

export function tabActionVariant(action: TabAction): ButtonVariant {
  if (
    action === 'CANCEL' ||
    action === 'MARK_LOSS' ||
    action === 'REFUND' ||
    action === 'PARTIAL_REFUND'
  ) {
    return 'danger';
  }
  return 'outline';
}
